import React from "react";
import { Table, TableCell, TableHead, TableRow } from '@material-ui/core';

const bg = { backgroundColor: '#fafafa' };

const ObservationHeader = ({}) => {
    return(
        <TableHead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
            <TableRow>
                <TableCell style={bg}>Section Name</TableCell>
                <TableCell colSpan={3} style={bg}>
                    <Table>
                        <TableRow>
                            <TableCell align="center" colSpan={3} style={bg}>Conditions</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center" style={{...bg, width:'100px'}}>Poor</TableCell>
                            <TableCell align="center" style={{...bg, width:'100px'}}>Average</TableCell>
                            <TableCell align="center" style={{...bg, width:'100px'}}>Good</TableCell>
                        </TableRow>
                    </Table>
                </TableCell>
                <TableCell style={bg}>Total</TableCell>
                <TableCell align="right" style={bg}>Action</TableCell>
            </TableRow>
        </TableHead>
    )
}
export default ObservationHeader;